export default "__VITE_ASSET__DAHFJ5mD__"